import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "./TopBar";
import Sidebar from "./Sidebar";

const DashboardLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen bg-[#DCCFB9] text-[#2A1C15] flex flex-col">
      <TopBar menuOpen={menuOpen} onToggleMenu={() => setMenuOpen((v) => !v)} />
      <div className="flex flex-1 min-h-0 min-w-0">
        <Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />
        <main
          data-testid="main-content"
          className="flex-1 min-w-0 overflow-x-hidden px-5 py-8 sm:px-8 min-[960px]:px-10 min-[960px]:py-10"
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
